import { FC } from 'react'
import { Tour } from 'antd'
import { TOUR_TARGET_IDS } from './tour-targets'
import { buildSteps } from './build-steps'
import LearnerProductTourNudge from './LearnerProductTourNudge'
import './learner-product-tour.css'

type Props = {
  open: boolean
  current: number
  setCurrent: (current: number) => void
  handleSkip: () => void
  showNudge: boolean
  dismissNudge: () => void
  studentPlanSectionEnabled?: boolean
}

const LearnerProductTour: FC<Props> = ({
  open,
  current,
  setCurrent,
  handleSkip,
  showNudge,
  dismissNudge,
  studentPlanSectionEnabled
}) => {
  const steps = open ? buildSteps(studentPlanSectionEnabled) : []

  return (
    <>
      {open && !!steps?.length && (
        <Tour
          open={open}
          current={current}
          onChange={setCurrent}
          onClose={handleSkip}
          // Prototype uses a "Skip tour" text control in the top-right corner instead of an X.
          closeIcon={<span className="learner-product-tour-skip">Skip tour</span>}
          // Round the mask cut-out corners to match the tooltip's 18px border-radius.
          gap={{ radius: 18 }}
          // Every step but the last fully blocks interaction; the last step opens a hole over the
          // first activity card so clicking it starts the activity and completes the tour.
          disabledInteraction={current !== steps.length - 1}
          rootClassName="learner-product-tour"
          indicatorsRender={(currentStep, total) => (
            <span className="learner-product-tour-indicator">
              Step {currentStep + 1} of {total}
            </span>
          )}
          scrollIntoViewOptions={{ block: 'center' }}
          steps={steps}
        />
      )}
      {showNudge && <LearnerProductTourNudge targetId={TOUR_TARGET_IDS.firstActivityCard} onDismiss={dismissNudge} />}
    </>
  )
}

export default LearnerProductTour
